import React from 'react';
import InputWrap from './InputWrap';
import styles from './styles/VehicleSelect.module.scss';
import { IFormFieldProps } from './common';

export interface ISelectProps extends IFormFieldProps {
  creatable?: boolean;
  search?: boolean;
  options: any[];
  tooltipPopup?: boolean;
}

const VehicleSelect = ({
  children,
  basic,
  label,
  labelAfter,
  description,
  className,
  inputClassName,
  labelClassName,
  leftIcon,
  rightIcon,
  error,
  info,
  options,
  placeholder,
  tooltip,
  onChange,
  scrollIntoView,
  value,
  tooltipPopup,
  ...inputProps
}: ISelectProps) => {
  return (
    <InputWrap
      className={className}
      errorClassName={classnames(styles.error, basic && styles.basicError)}
      error={error}
      label={label}
      labelClassName={labelClassName}
      name={inputProps.name}
      rightIcon={rightIcon}
      scrollIntoView={scrollIntoView}
      tooltipPopup={tooltipPopup}
    >
      <div className={styles.vSelectInputContainer}>
        <select
          name={inputProps.name}
          id={inputProps.name}
          className={styles.vehicleSelect}
          onChange={onChange}
          value={value || ''}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option value={option.value}>{option.text}</option>
          ))}
        </select>
      </div>

      {children}
    </InputWrap>
  );
};

export default VehicleSelect;
